import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { setMarathonParticipantImagesPage } from "api/slice/marathonsSlice/marathonsSlice";
import { getMarathonParticipantImages } from "api/thunk/marathons/getActions/getMarathonParticipantImages";
import { getMyMarathonParticipantImages } from "api/thunk/marathons/getActions/getMyMarathonParticipantImages";
import AllPhotos from "pages/AllPhotos/AllPhotos";
import MyPhotos from "pages/MyPhotos/MyPhotos";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector, useDebounce } from "shared/lib/hooks/hooks";

const Photos = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  const { marathonId } = useParams();
  const { page: allImagesPage, pageSize: allImagesPageSize } = useAppSelector((state) => state.marathons.marathonParticipantImages.params);
  const { page: myImagesPage, pageSize: myImagesPageSize } = useAppSelector((state) => state.marathons.marathonMyParticipantImages.params);

  useEffect(() => {
    if (!marathonId) return;

    dispatch(getMarathonParticipantImages({
      marathonId: Number(marathonId),
      page: allImagesPage,
      pageSize: allImagesPageSize,
      startNumber: debouncedSearch ? Number(debouncedSearch) : undefined,
    }));

  }, [dispatch, marathonId, allImagesPage, allImagesPageSize, debouncedSearch]);

  useEffect(() => {
    if (!marathonId) return;

    dispatch(getMyMarathonParticipantImages({
      marathonId: Number(marathonId),
      page: myImagesPage,
      pageSize: myImagesPageSize,
    }));
  }, [dispatch, marathonId, myImagesPage, myImagesPageSize]);


  useEffect(() => {
    dispatch(setMarathonParticipantImagesPage(1));
  }, [dispatch, debouncedSearch]);

  return (
    <Box>
      <Paper
        sx={{
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "none",
        }}
      >
        <section>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: "600" }} component="h2">
              {t("photoGallery.title")}
            </Typography>
          </Box>

          <Tabs
            value={activeTab}
            onChange={(_, newValue) => setActiveTab(newValue)}
            sx={{ mt: 2 }}
          >
            <Tab label={t("photoGallery.allPhotos")} />
            <Tab label={t("photoGallery.myPhotos")} />
          </Tabs>

          <Box sx={{ mt: 2 }}>
            {activeTab === 0 && (
              <Box>
                <AllPhotos
                  search={search}
                  setSearch={setSearch}
                />
              </Box>
            )}
            {activeTab === 1 && (
              <Box>
                <MyPhotos />
              </Box>
            )}
          </Box>
        </section>
      </Paper>
    </Box>
  );
};

export default Photos; 